// Modules
import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledBox = styled.div`
    background-color: ${theme.colors.yellows[100]};
    border: 1px solid ${theme.colors.yellows[70]};
    border-radius: ${theme.radii.small};
    width: 100%;
    padding: 16px;
    margin-bottom: 32px;

    .header {
        display: flex;
        align-items: center;
    }

    .header__title {
        color: ${theme.colors.grays[50]};
        font-weight: ${theme.fontWeights.normal};
        font-size: ${theme.fontSizes.xxmedium};
        margin-left: ${theme.space[1]};
        letter-spacing: 0.8px;
    }

    .paragraph {
        font-size: ${theme.fontSizes.xmedium};
        margin: 8px 4px;
    }

    .footer {
        font-size: ${theme.fontSizes.xmedium};
        display: flex;
    }

    .footer__icon {
        transform: rotate(135deg);
    }

    & > button {
        font-family: 'Dasa Sans', 'Montserrat', sans-serif;
        margin: 8px 4px;
        background: none;
        color: ${theme.colors.primary};
        text-decoration: underline;
        cursor: pointer;
        border: 0;
    }
`
